import { Button } from '@progress/kendo-react-buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { DashboardTileHeader } from '../../components/dashboard/dashboard-tile-header.tsx';
import { DashboardTileContent } from '../../components/dashboard/dashboard-tile-content.tsx';
import type { JobStatusTileProps } from './job-status-tile.types.ts';
import { useNavigate } from 'react-router-dom';
import {
  Chart,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartTooltip,
  type TooltipContext,
} from '@progress/kendo-react-charts';
import { NoDataRender } from '../../components/render/no-data-render.tsx';
import styles from './job-status-tile.module.scss';

export function JobStatusTile({ data }: JobStatusTileProps) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/sampling-board/status');
  };

  return (
    <>
      <DashboardTileHeader>
        Job Status Report
        <Button onClick={handleNavigate}>
          <FontAwesomeIcon icon={faArrowRight} size={'sm'} />
        </Button>
      </DashboardTileHeader>
      <DashboardTileContent className={styles.content}>
        {data.length === 0 ? (
          <NoDataRender className={styles.render} message={'No jobs found for current season.'} />
        ) : (
          <Chart className={styles.chart}>
            <ChartLegend position={'left'} labels={{ margin: { right: 10 } }} />
            <ChartTooltip render={({ point }: TooltipContext) => `${point?.category}: ${point?.value}`} />
            <ChartSeries>
              <ChartSeriesItem
                type={'donut'}
                holeSize={50}
                data={data}
                categoryField={'statusTitle'}
                field={'jobCount'}
              />
            </ChartSeries>
          </Chart>
        )}
      </DashboardTileContent>
    </>
  );
}
